import React, { Component } from 'react'
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";

class Report extends Component {
  constructor() {
    super();
    this.state = {
      startDate: {},
      endDate: {},
    };

    this.downloadReport = this.downloadReport.bind(this);
    this.downloadWaitingTimeReport = this.downloadWaitingTimeReport.bind(this);
    this.downloadKpiReport = this.downloadKpiReport.bind(this);
    this.updateDataState = this.updateDataState.bind(this);
    this.downloadPerformanceReport = this.downloadPerformanceReport.bind(this);
  }

  componentWillMount() {
    this.setState({
      startDate: new Date(),
      endDate: new Date(),
    });
  }

  downloadReport() {
    window.open(`/api/adminPanel/reports/download?startDate=${moment(this.state.startDate).utc().format()}&endDate=${moment(this.state.endDate).utc().format()}`, '_blank');
  }

  downloadWaitingTimeReport() {
    window.open(`/api/adminPanel/waiting-time-reports/download?startDate=${moment(this.state.startDate).utc().format()}&endDate=${moment(this.state.endDate).utc().format()}`, '_blank');
  }

  downloadKpiReport() {
    window.open(`/api/adminPanel/kpi-reports/download?startDate=${moment(this.state.startDate).utc().format()}&endDate=${moment(this.state.endDate).utc().format()}`, '_blank');
  }

  downloadPerformanceReport() {
    window.open(`/api/adminPanel/performance-reports/download?startDate=${moment(this.state.startDate).utc().format()}&endDate=${moment(this.state.endDate).utc().format()}`, '_blank');
  }

  updateDataState(field, alwaysNull, newDate) {
    this.setState({
      [field]: newDate,
    });
  }

  render() {
    return (
      <div>
        <div style={{
          height: 100,
        }}>
          <DatePicker
            floatingLabelText="報告日期(Start)"
            floatingLabelFixed={true}
            container="inline"
            defaultDate={this.state.startDate}
            onChange={this.updateDataState.bind(this, 'startDate')}
            value={this.state.startDate}
            DateTimeFormat={global.Intl.DateTimeFormat}
            firstDayOfWeek={0}
            locale="zh-HK"
            okLabel="確定"
            cancelLabel="取消"
            style={{
              float: 'left',
            }}
          />
          <DatePicker
            floatingLabelText="報告日期(End)"
            floatingLabelFixed={true}
            container="inline"
            defaultDate={this.state.endDate}
            onChange={this.updateDataState.bind(this, 'endDate')}
            value={this.state.endDate}
            DateTimeFormat={global.Intl.DateTimeFormat}
            firstDayOfWeek={0}
            locale="zh-HK"
            okLabel="確定"
            cancelLabel="取消"
            style={{
              float: 'left',
              marginLeft: 10,
            }}
          />
        </div>
        <div>
          <RaisedButton
            label="Raw Data"
            primary={true}
            onClick={this.downloadReport} />
          {/*<RaisedButton*/}
          {/*  label="Waiting Time Summary"*/}
          {/*  secondary={true}*/}
          {/*  style={{*/}
          {/*    marginLeft: 10,*/}
          {/*  }}*/}
          {/*  onClick={this.downloadWaitingTimeReport} />*/}
          {/*<RaisedButton*/}
          {/*  label="KPI"*/}
          {/*  style={{*/}
          {/*    marginLeft: 10,*/}
          {/*  }}*/}
          {/*  onClick={this.downloadKpiReport} />*/}
          {/*<RaisedButton*/}
          {/*  label="Performance"*/}
          {/*  primary={true}*/}
          {/*  style={{*/}
          {/*    marginLeft: 10,*/}
          {/*  }}*/}
          {/*  onClick={this.downloadPerformanceReport} />*/}
          <Dialogs onInit={dialog => (this.dialogs = dialog)} />
        </div>
      </div>
    )
  }
}

export default Report;


// WEBPACK FOOTER //
// client/adminPanel/panel/reports/Report.js